import { render, staticRenderFns } from "./XueLiangLogin.vue?vue&type=template&id=4019fa63&scoped=true"
import script from "./XueLiangLogin.vue?vue&type=script&lang=js"
export * from "./XueLiangLogin.vue?vue&type=script&lang=js"
import style0 from "./XueLiangLogin.vue?vue&type=style&index=0&id=4019fa63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019fa63",
  null
  
)

export default component.exports